// extracted by mini-css-extract-plugin
export default {"pageSubheader":"F2FTb","pageSubheaderWrapper":"KVuzq","text":"xS0gB","multiline":"Xk8WB","container":"IssgO","widgets":"_Q02q"};